document.addEventListener('scroll', function (e) {
  var scroller = e.target;
  if (!scroller.matches || !scroller.matches('slideshow-slides')) return;

  var gallery = scroller.closest('.card-gallery');
  if (!gallery) return;

  var dots = gallery.querySelectorAll('.card-gallery-dots__dot');
  if (!dots.length) return;

  var slideWidth = scroller.offsetWidth;
  if (!slideWidth) return;

  var index = Math.round(scroller.scrollLeft / slideWidth);
  dots.forEach(function (dot, i) {
    dot.classList.toggle('is-active', i === index);
  });
}, true); 

// countdown delivery date
window.initDeliveryCountdown = function (root = document) {
  const containers = root.querySelectorAll('.countdown-timer-container');

  containers.forEach((container) => {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const hourEl = container.querySelector('[id^="hours-"]');
    const minuteEl = container.querySelector('[id^="minutes-"]');
    const deliveryDateEl = container.querySelector('[id^="uk-delivery-date-"]');

    if (!hourEl || !minuteEl) return;

    function setUkDeliveryDate(daysToAdd) {
      if (!deliveryDateEl) return;

      // Naya format: Receive "tomorrow"
      if (daysToAdd === 1) {
        deliveryDateEl.textContent = 'tomorrow';
      } else {
        const deliveryDate = new Date();
        deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

        deliveryDateEl.textContent = deliveryDate.toLocaleDateString('en-GB', {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
      }
    }

    const interval = setInterval(() => {
      const hourThreshold = 15;
      const minutesThreshold = 0;
      const saturdayHourThreshold = 12;

      const countDownDateTime = (hourThreshold * 3600000) + (minutesThreshold * 60000);
      const saturdayCountDownDateTime = (saturdayHourThreshold * 3600000) + (minutesThreshold * 60000);

      const dt = new Date();
      const ukTimeString = dt.toLocaleString('en-GB', { timeZone: 'Europe/London' });

      const [datePart, timePart] = ukTimeString.split(', ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hours_time, minutes_time, seconds_time] = timePart.split(':').map(Number);

      const ukDate = new Date(year, month - 1, day, hours_time, minutes_time, seconds_time || 0);
      const todayWeekName = ukDate.getDay();

      const totalMs = (hours_time * 3600000) + (minutes_time * 60000) + ((seconds_time || 0) * 1000);

      if (todayWeekName >= 1 && todayWeekName <= 5) {
        let difference = countDownDateTime - totalMs;

        if (difference <= 0) {
          difference += (24 * 60 * 60 * 1000);
        }

        const h = Math.floor(difference / 3600000);
        const m = Math.floor((difference % 3600000) / 60000);

        hourEl.textContent = h;
        minuteEl.textContent = m;

        setUkDeliveryDate(1);
        container.style.display = '';

      } else if (todayWeekName === 6) {
        let difference = saturdayCountDownDateTime - totalMs;

        if (difference <= 0) {
          container.style.display = 'none';
          clearInterval(interval);
        } else {
          const h = Math.floor(difference / 3600000);
          const m = Math.floor((difference % 3600000) / 60000);

          hourEl.textContent = h;
          minuteEl.textContent = m;

          setUkDeliveryDate(1);
          container.style.display = '';
        }
      } else {
        container.style.display = 'none';
      }
    }, 1000);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.initDeliveryCountdown();
});
// end countdown script.


document.addEventListener('DOMContentLoaded', () => {
    $(".rmh-drawer-search.rmh-drawer-only input").click(function (e) {
    e.preventDefault()
    console.log("ssss")
    $(".mobile-search-trigger input").trigger("click")
});

// Open modal
$(document).on("click", ".dfd-card button.wk-button-product.wk-add-product", function (e) {
    e.preventDefault();

    $(".modal.wishlist_popup").show();
    $("#myModal").show(); // or .css("display", "block")
});

// Close modal on close button click
$(document).on("click", "#myModal .close", function () {
    $("#myModal").hide();
});

// Close modal when clicking outside the modal content
$(window).on("click", function (e) {
    if ($(e.target).is("#myModal")) {
        $("#myModal").hide();
    }
});

  });


document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(function(mutations) {
    const klaviyoImg = document.querySelector('.klaviyo-form-image img');
    if (klaviyoImg && !klaviyoImg.hasAttribute('title')) {
      klaviyoImg.setAttribute('title', klaviyoImg.getAttribute('alt') || 'pretavoir logo');
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".text-block a").forEach(link => {
    if (!link.hasAttribute("title")) {
      link.setAttribute("title", link.textContent.trim() || "External Link");
    }
  });
});



document.addEventListener("DOMContentLoaded", function() {
  const checkCookieLink = setInterval(() => {
    const cookieLink = document.querySelector('a.cc-link[href*="privacy-policy"]') || document.querySelector('span[id="cookieconsent:desc"] a.cc-link');
    
    if (cookieLink) {
      cookieLink.setAttribute('title', 'Learn More about cookies');
      clearInterval(checkCookieLink);
    }
  }, 500);
});

document.addEventListener("DOMContentLoaded", function() {
  const checkHeroImg = setInterval(() => {
    const heroImg = document.querySelector('picture.hero__media img, img.hero__media');
    
    if (heroImg && !heroImg.hasAttribute('title')) {
      const altText = heroImg.getAttribute('alt') || 'Hero Banner';
      heroImg.setAttribute('title', altText);
      clearInterval(checkHeroImg);
    }
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {

  console.log("CUSTOM JS FILE LOADED");

  var header = document.querySelector("#header-menu");
  var pageWrapper = document.querySelector(".page-wrapper");
  var html = document.documentElement;
  var body = document.body;

  if (!header) {
    console.log("HEADER NOT FOUND");
    return;
  }

  function checkSticky() {

    var htmlScroll = html.scrollTop || 0;
    var bodyScroll = body.scrollTop || 0;
    var wrapperScroll = pageWrapper ? pageWrapper.scrollTop : 0;

    // Actual scroll position hai, use detect karo
    var scrollTop = Math.max(
      htmlScroll,
      bodyScroll,
      wrapperScroll
    );
    if(window.innerWidth <= 989){
      if (scrollTop > 38) {
        header.classList.add("sticky-header");
      } else {
        header.classList.remove("sticky-header");
      }
    } else{
      if (scrollTop > 45) {
        header.classList.add("sticky-header");
      } else {
        header.classList.remove("sticky-header");
      }
    }
  }

  // Page wrapper scroll
  if (pageWrapper) {
    pageWrapper.addEventListener("scroll", checkSticky, {
      passive: true
    });
  }
  // HTML scroll
  html.addEventListener("scroll", checkSticky, {
    passive: true
  });
  // Body scroll
  body.addEventListener("scroll", checkSticky, {
    passive: true
  });
  // Fallback
  window.addEventListener("scroll", checkSticky, {
    passive: true
  });
  // Initial check
  checkSticky();
});

// ===== Searchanise card title = Model Number + Colour Code (fallback: original title) =====
// (function () {
//   // Optional: paste a token here only if the theme doesn't expose one
//   var MANUAL_TOKEN = '';
//   var API_URL = '/api/2024-10/graphql.json';
//   var DEBUG = true;

//   var cache = {};    // handle -> { modelNo, colorCode }
//   var loading = {};  // handle -> Promise

//   function log() {
//     if (DEBUG) console.log.apply(console, ['[Title override]'].concat([].slice.call(arguments)));
//   }
//   function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }

//   function getToken() {
//     return MANUAL_TOKEN ||
//       (window.Shopify && window.Shopify.theme && window.Shopify.theme.storefrontAccessToken) ||
//       window.storefrontAccessToken || '';
//   }

//   function getHandle(card) {
//     var link = card.querySelector('a.snize-view-link');
//     if (!link) return null;
//     var parts = link.getAttribute('href').split('/products/');
//     if (parts.length < 2) return null;
//     return decodeURIComponent(parts[1].split('?')[0].split('#')[0].replace(/\/$/, ''));
//   }

//   function fetchMeta(handle) {
//     if (cache[handle]) return Promise.resolve(cache[handle]);
//     if (loading[handle]) return loading[handle];

//     var query = 'query($h:String!){ product(handle:$h){ ' +
//       'model: metafield(namespace:"custom_fields", key:"model_number"){ value } ' +
//       'color: metafield(namespace:"custom_fields", key:"colour_code"){ value } } }';

//     loading[handle] = fetch(API_URL, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-Shopify-Storefront-Access-Token': getToken()
//       },
//       body: JSON.stringify({ query: query, variables: { h: handle } })
//     })
//       .then(function (r) { return r.json(); })
//       .then(function (json) {
//         if (json.errors) console.error('[Title override] API errors:', JSON.stringify(json.errors));
//         var p = json && json.data && json.data.product;
//         var meta = {
//           modelNo: clean(p && p.model && p.model.value),
//           colorCode: clean(p && p.color && p.color.value)
//         };
//         log(handle, '=>', JSON.stringify(meta));
//         cache[handle] = meta;
//         delete loading[handle];
//         return meta;
//       })
//       .catch(function (e) {
//         console.error('[Title override] request failed', handle, e);
//         delete loading[handle];
//         return { modelNo: '', colorCode: '' };
//       });

//     return loading[handle];
//   }

//   function setTitle(titleEl, text) {
//     if (titleEl.textContent !== text) titleEl.textContent = text;
//     titleEl.setAttribute('title', text);
//   }

//   function process(card) {
//     var titleEl = card.querySelector('.snize-title');
//     if (!titleEl || titleEl.getAttribute('data-mc-watch')) return;

//     var handle = getHandle(card);
//     if (!handle) return;

//     titleEl.setAttribute('data-mc-watch', '1');

//     fetchMeta(handle).then(function (meta) {
//       var display = (meta.modelNo + ' ' + meta.colorCode).trim();
//       if (!display) return; // no metafields -> keep original title

//       setTitle(titleEl, display);

//       // If Searchanise or other code overwrites the title, put ours back
//       new MutationObserver(function () {
//         if (titleEl.textContent !== display) setTitle(titleEl, display);
//       }).observe(titleEl, { childList: true, characterData: true, subtree: true });
//     });
//   }

//   function run() {
//     document.querySelectorAll('li.snize-product').forEach(process);
//   }

//   document.addEventListener('Searchanise.Loaded', function () {
//     window.Searchanise.$(document).on('Searchanise.ResultsUpdated', function () {
//       setTimeout(run, 150);
//     });
//   });

//   var t = null;
//   new MutationObserver(function () {
//     clearTimeout(t);
//     t = setTimeout(run, 200);
//   }).observe(document.body, { childList: true, subtree: true });

//   run();
// })();

//=================Lens advisor product remove cart page Start================= //
(function () {
  if (window.__bundleSyncInit) return;
  window.__bundleSyncInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var pendingRemovalData = null;
  var isUpdating = false;
  var cartBundleMap = {}; // key -> _bundleId

  // ---------- Header cart bubble refresh ----------
  function refreshHeaderCartIcon() {
    return fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;

        document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) {
          el.textContent = count > 0 ? String(count) : '';
        });
        document.querySelectorAll('[ref="cartBubble"], .cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', count === 0);
          el.classList.toggle('hidden', count === 0);
        });
        try {
          sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
        } catch (e) {}

        var icon = document.querySelector('cart-icon');
        var sec = icon && icon.closest('[id^="shopify-section-"]');
        if (!sec) return;

        var id = sec.id.replace('shopify-section-', '');
        return fetch(ROOT + '?sections=' + id + '&t=' + Date.now())
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var doc = new DOMParser().parseFromString(data[id], 'text/html');
            var newIcon = doc.querySelector('cart-icon');
            if (newIcon) icon.innerHTML = newIcon.innerHTML;
          });
      })
      .catch(function (err) { console.warn('Header cart icon refresh failed', err); });
  }
  window.refreshHeaderCartIcon = refreshHeaderCartIcon; // app JS bhi use kar sake

  // ---------- Cart JSON se key -> _bundleId map ----------
  function fetchAndMapCartBundles() {
    return fetch(ROOT + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartBundleMap = {};
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            var bundleId = item.properties && item.properties._bundleId;
            if (bundleId) cartBundleMap[item.key] = String(bundleId);
          });
        }
        return cartBundleMap;
      })
      .catch(function (err) { console.error('Error fetching cart bundle data:', err); });
  }

  // Koi bhi /cart/add|change|update|clear call ho to map + header bubble refresh
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var p = _fetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { return fetchAndMapCartBundles(); })
         .then(function () { refreshHeaderCartIcon(); })
         .catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  function getLinkedChildKeys(parentKey) {
    if (!parentKey || !cartBundleMap[parentKey]) return [];
    var parentBundleId = cartBundleMap[parentKey];
    return Object.keys(cartBundleMap).filter(function (key) {
      return key !== parentKey && cartBundleMap[key] === parentBundleId;
    });
  }

  function syncAllQuantities(parentKey, childKeys, newQuantity) {
    isUpdating = true;
    var updates = {};
    if (parentKey) updates[parentKey] = newQuantity;
    childKeys.forEach(function (key) { updates[key] = newQuantity; });

    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        updateCartBubble(cartData.item_count);
        dispatchCartEvents(cartData);
        refreshCartSection();
      })
      .catch(function (err) { console.error('Cart quantity sync error:', err); })
      .finally(function () { isUpdating = false; });
  }

  // ---------- Quantity change ----------
  document.addEventListener('change', function (e) { handleQuantityChange(e.target); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button, [name="plus"], [name="minus"]');
    if (!btn) return;
    var qtyContainer = btn.closest('.quantity, cart-remove-button, .cart-items__table-row');
    var input = qtyContainer ? qtyContainer.querySelector('input[name="updates[]"], .quantity__input') : null;
    if (input) setTimeout(function () { handleQuantityChange(input); }, 50);
  });

  function handleQuantityChange(input) {
    if (!input || isUpdating) return;
    var qtyInput = input.closest('input[name="updates[]"], .quantity__input');
    if (!qtyInput) return;
    var row = qtyInput.closest('.cart-items__table-row');
    if (!row || !row.dataset.key) return;

    var parentKey = row.dataset.key;
    var newQty = parseInt(qtyInput.value, 10);
    if (isNaN(newQty)) return;

    var linkedKeys = getLinkedChildKeys(parentKey);
    if (linkedKeys.length > 0) syncAllQuantities(parentKey, linkedKeys, newQty);
  }

  // ---------- Remove ----------
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-items__remove, .cart-remove-button');
    if (!removeBtn) return;
    var row = removeBtn.closest('.cart-items__table-row');
    if (!row || !row.dataset.key) return;

    var parentKey = row.dataset.key;
    var linkedKeys = getLinkedChildKeys(parentKey);
    pendingRemovalData = linkedKeys.length > 0
      ? { parentKey: parentKey, childKeys: linkedKeys, time: Date.now() }
      : null;
  }, true);

  function watchCartRemoval() {
    var observer = new MutationObserver(function (mutations) {
      if (!pendingRemovalData) return;
      if (Date.now() - pendingRemovalData.time > 5000) { pendingRemovalData = null; return; }

      var parentKey = pendingRemovalData.parentKey;
      var removed = mutations.some(function (m) {
        return Array.prototype.some.call(m.removedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.dataset && node.dataset.key === parentKey) ||
            (node.querySelector && node.querySelector('[data-key="' + parentKey + '"]'))
          );
        });
      });

      if (removed) {
        var childKeys = pendingRemovalData.childKeys;
        pendingRemovalData = null;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { removeLinkedItems(childKeys); });
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function fadeOutLinkedRows(childKeys) {
    document.querySelectorAll('.cart-items__table-row').forEach(function (r) {
      if (r.dataset.key && childKeys.indexOf(r.dataset.key) !== -1) {
        r.style.transition = 'opacity 0.2s ease';
        r.style.opacity = '0.3';
      }
    });
  }

  function removeLinkedItems(childKeys) {
    if (childKeys && childKeys.length > 0) {
      fadeOutLinkedRows(childKeys);
      syncAllQuantities(null, childKeys, 0);
    }
  }

  // ---------- Header cart count (instant) ----------
  function updateCartBubble(count) {
    if (typeof count !== 'number') return;

    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count, .cart-count-bubble, #cart-icon-bubble span, .header__cart-count, [data-cart-count]')
      .forEach(function (el) {
        el.textContent = count > 0 ? String(count) : '';
        if (count === 0) el.style.setProperty('display', 'none', 'important');
        else el.style.removeProperty('display');
      });

    document.querySelectorAll('[ref="cartBubble"], .cart-bubble, .cart-count-bubble, #cart-icon-bubble .cart-count-bubble, .header-actions__cart-icon-bubble, .header__cart-badge')
      .forEach(function (el) {
        if (count === 0) {
          el.classList.add('visually-hidden', 'hidden');
          el.style.setProperty('display', 'none', 'important');
        } else {
          el.classList.remove('visually-hidden', 'hidden');
          el.style.removeProperty('display');
        }
      });

    document.querySelectorAll('cart-icon, .cart-icon, #cart-icon-bubble').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      if (count === 0) el.classList.remove('has-cart', 'header-actions__cart-icon--has-cart');
    });

    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (_) {}
  }

  function dispatchCartEvents(cartData) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartData } }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cartData } }));
    if (window.Shopify && Shopify.theme && Shopify.theme.cart) {
      document.dispatchEvent(new CustomEvent('shopify:cart:change', { detail: cartData }));
    }
  }

  // ---------- Drawer + Cart page section refresh ----------
  function refreshCartSection() {
    var drawer = document.querySelector('cart-drawer-component');

    // A) Horizon cart drawer
    if (drawer) {
      var sec = drawer.closest('[id^="shopify-section-"]');
      if (!sec) return;
      var drawerSectionId = sec.id.replace('shopify-section-', '');

      fetch(ROOT + '?sections=' + drawerSectionId + '&t=' + Date.now())
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data[drawerSectionId];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newDrawer = doc.querySelector('cart-drawer-component');
          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;

          fetchAndMapCartBundles();
          refreshHeaderCartIcon();
        })
        .catch(function (err) { console.warn('Drawer refresh failed', err); });
      return;
    }

    // B) Normal cart page
    var sectionEl = document.querySelector('[data-section-id], cart-items');
    var sectionId = sectionEl && (sectionEl.dataset.sectionId ||
      (sectionEl.getAttribute('id') || '').replace('shopify-section-', ''));
    if (!sectionId) return;

    fetch(ROOT + 'cart?sections=' + sectionId)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newHeaderBubble = doc.querySelector('#cart-icon-bubble, [ref="cartBubble"], .cart-bubble, .cart-count-bubble');
        var oldHeaderBubble = document.querySelector('#cart-icon-bubble, [ref="cartBubble"], .cart-bubble, .cart-count-bubble');
        if (newHeaderBubble && oldHeaderBubble) oldHeaderBubble.innerHTML = newHeaderBubble.innerHTML;

        var newSection = doc.getElementById('shopify-section-' + sectionId) || doc.querySelector('cart-items');
        var oldSection = document.getElementById('shopify-section-' + sectionId) || document.querySelector('cart-items');
        if (newSection && oldSection) {
          oldSection.replaceWith(newSection);
          fetchAndMapCartBundles();
        }
      });
  }

  // ---------- Init ----------
  function init() {
    watchCartRemoval();
    fetchAndMapCartBundles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
//=================Lens advisor product remove cart page End================= //

(function() {
  function getHandleFromElement(container) {
    // 1. Direct product link se try karo (/products/handle)
    const productLink = container.querySelector('a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      const match = href.match(/\/products\/([a-zA-Z0-9-_]+)/);
      if (match && match[1]) return match[1];
    }

    // 2. Image tag, alt text ya src se handle nikaalo
    const img = container.querySelector('img');
    if (img) {
      // Searchanise thumbnail src me product handle/id hota h
      const src = img.getAttribute('src') || '';
      const srcMatch = src.match(/\/products\/([a-zA-Z0-9-_]+)/);
      if (srcMatch && srcMatch[1]) return srcMatch[1];

      // Image alt text ko handle format me convert karo (e.g. "Tom Ford TF5294" -> "tom-ford-tf5294")
      const alt = img.getAttribute('alt');
      if (alt && alt.trim() !== '') {
        return alt.toLowerCase().trim().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-');
      }
    }

    // 3. Parent container ke title/text se handle try karo
    const titleEl = container.querySelector('.snize-title, .product-title, .card__heading, a');
    if (titleEl && titleEl.textContent) {
      return titleEl.textContent.toLowerCase().trim().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-');
    }

    return null;
  }

  function fixWishlistHandles() {
    const wishlistElements = document.querySelectorAll('wishlist-button-collection:not([data-product-handle])');

    wishlistElements.forEach((el) => {
      // Container ko parent elements tak search karo
      const parentCard = el.closest('.snize-product, .snize-item, .card, .product-card, .grid__item, div[class*="product"]');
      const wrapper = parentCard || el.parentElement;

      if (wrapper) {
        const handle = getHandleFromElement(wrapper);
        if (handle) {
          el.setAttribute('data-product-handle', handle);
        }
      }
    });
  }

  // Page Load par chalega
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixWishlistHandles);
  } else {
    fixWishlistHandles();
  }

  // Dynamic Search/Filters (Searchanise Ajax) ke liye Auto Observer
  const observer = new MutationObserver(() => {
    fixWishlistHandles();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  const newInputHTML = `
    <input
      class="doofinder-custom-jtpl snize-input-style"
      type="text"
      name="q"
      id="search-mobile"
      placeholder="Search designers or brands"
    >
  `;

  function checkSearchInput() {
    const input = document.querySelector('#search-mobile');

    if (
      input &&
      input.getAttribute('aria-autocomplete') === 'list' &&
      input.getAttribute('aria-expanded') === 'true'
    ) {
      input.outerHTML = newInputHTML;
    }
  }
  // Immediately check
  checkSearchInput();
  // Keep watching for dynamically added/changed attributes
  const observer = new MutationObserver(() => {
    checkSearchInput();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-autocomplete', 'aria-expanded']
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  function updateNavId() {
    const nav = document.querySelector("#main-nav");
    if (!nav) return;
    if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
      nav.id = "accordion";
    } else {
      nav.id = "main-nav";
    }
  }
  updateNavId();
  window.addEventListener("resize", updateNavId);
//************** Cart drawer close(Outside click) Start ***************/ 
$("body").click(function(event) {
    if ($(event.target).closest(".rmh-icon-btn.rmh-bag").length > 0) {
        return;
    }
    if ($(".page-wrapper").hasClass("page-wrapper--drawer-open")) {
        if (
            $(event.target).closest(".cart-items__empty-button").length > 0 ||
            $(event.target).closest("cart-drawer-component").length === 0
        ) {
            $(".theme-drawer__close-button").click();
        }
    }
});
//************** Cart drawer close(Outside click) End ***************/ 
});
document.addEventListener("DOMContentLoaded", function () { 
    document.querySelector('#shopify-block-AWnI5ZmRDQmVXSEhJS__announcement_bar_DTbgzM')?.classList.add('loaded');
    document.querySelector('#shopify-block-AUUZ2c0lOci9MOExrT__brand_strip_8am7aL')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__section_4LVCnR')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__featured_blog_posts_tdpPpJ')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__section_iQgP8e')?.classList.add('loaded');
    const observer = new MutationObserver(() => {
    const img = document.querySelector('img[title="Find Your Style"]');
    if (img) {
      img.setAttribute('width', '90');
      img.setAttribute('height', '25');
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  document.querySelector("[data-testid='hero-desktop-video-1'] img")?.setAttribute("alt", "Poster Image");
});
$(document).ready(function(){
    document.querySelector('#shopify-block-AWnI5ZmRDQmVXSEhJS__announcement_bar_DTbgzM')?.classList.add('loaded');
    document.querySelector('#shopify-block-AUUZ2c0lOci9MOExrT__brand_strip_8am7aL')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__section_4LVCnR')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__featured_blog_posts_tdpPpJ')?.classList.add('loaded');
    document.querySelector('#shopify-section-template--22433499644075__section_iQgP8e')?.classList.add('loaded');
});